// extracted by mini-css-extract-plugin
export default {"container":"container__Ozbt8mTCmLyeICJq1js6j","label":"label__3hjM1abzvFMPNlCfoW4ONx","element":"element__6aAOt_664mto1AqRDtF_0","favicon":"favicon__sDZWlPymTBwfk1memvpmI"};